export default __webpack_public_path__ + "static/media/Foresters.d98745e0.jpg";